<template>
  <div class="categories-page">
    <!-- 根据路由模式显示不同组件 -->
    <MainCategory
      v-if="mode === 'main' && mainCategoryData"
      :categoryData="mainCategoryData"
    />
    <SubCategory
      v-else-if="mode === 'sub' && subCategoryData"
      :categoryData="subCategoryData"
    />
    <div v-else class="loading-container">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
import MainCategory from "./Main.vue";
import SubCategory from "./Sub.vue";
import {
  getSubCategoriesByMain,
  getSubCategoryWithProducts,
  getMainCategoryById,
} from "@/api/productAPI";

export default {
  name: "CategoriesPage",
  components: {
    MainCategory,
    SubCategory,
  },
  props: {
    mode: {
      type: String,
      required: true,
      validator: (value) => ["main", "sub"].includes(value),
    },
    mainCategoryId: {
      type: [String, Number],
      default: null,
    },
    subCategoryId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      mainCategoryData: null,
      subCategoryData: null,
      isLoading: false,
    };
  },
  watch: {
    "$route.params": {
      immediate: true,
      handler() {
        this.fetchData();
      },
    },
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        if (this.mode === "main" && this.mainCategoryId) {
          // 1️⃣ 获取主分类基本信息
          const mainCategory = await getMainCategoryById(this.mainCategoryId);

          // 2️⃣ 获取子分类列表
          const subCategories = await getSubCategoriesByMain(
            this.mainCategoryId
          );

          // 3️⃣ 为每个子分类获取产品列表
          const subCategoryWithProducts = await Promise.all(
            subCategories.map(async (sub) => {
              const res = await getSubCategoryWithProducts(sub.id);
              return {
                ...sub,
                products: res.products.map((p) => ({
                  id: p.id,
                  productId: p.productId,
                  name: p.name,
                  coverImg: p.coverImg,
                })),
              };
            })
          );

          // 4️⃣ 组装主分类数据
          this.mainCategoryData = {
            id: mainCategory.id,
            name: mainCategory.name,
            subCategories: subCategoryWithProducts,
          };
        } else if (this.mode === "sub" && this.subCategoryId) {
          const response = await getSubCategoryWithProducts(this.subCategoryId);
          this.subCategoryData = {
            id: response.id,
            name: response.name,
            products: response.products.map((p) => ({
              id: p.id,
              productId: p.productId,
              name: p.name,
              coverImg: p.coverImg,
            })),
          };
        }
      } catch (error) {
        console.error("获取分类数据失败:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.categories-page {
  // padding-top: 6rem; /* 为header留出空间 */
  min-height: 100vh;
  background-color: @color-bg-gray;
}

.loading-container {
  .flex-center(column);
  height: 50vh;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid @color-primary;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
